import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transprerent;
  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  @media (max-width: 1366px) {
    width: 100%;
    height: 18px;
  }
`;
